/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n){return(r,t)=>{r[t]=n}}export{n as shared};
